// @flow
import { getCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  FETCH_PAYOUT: `${environment.apiUrl}/preferences/disbursement`,
});

// export const
export const fetchDisbursementInfoApi = getCreator(fetch, endpoints.FETCH_PAYOUT);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/completed/api.js